import Axios from '../config/axios';

export function modifyWorkHistory(postdata) {
    return Axios.post(`/api/ModifyWorkHistory`, postdata
    ).then(response => response.data).catch(error => error);
}